angular.module('routes.cases.states.StatesPayloadResolver', [
  'stack'
])

/**
 * The StatesPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class StatesPayloadResolver
 * @constructor
 * @module routes.cases.states.StatesPayloadResolver
 */
.factory('StatesPayloadResolver', [
  '$q',
  'GLOBAL',
  'ModelsService',
  function ($q, GLOBAL, ModelsService) {
    'use strict';

    return function (params) {
      if (params.stateId) {
        return ModelsService
          .get('states', GLOBAL.apiPath + '/states', { id: params.stateId })
          .then(function (response) {
            var queue = _(response.relatives)
              .filter(function (relative) {
                return relative.model === 'decisions' || relative.model === 'rules';
              })
              .map(function (relative) {
                return ModelsService
                  .get(relative.model, GLOBAL.apiPath + '/' + relative.model, { id: relative.id });
              })
              .value();

            return $q.all(queue);
          });
      }
      return {};
    };
  }
]);
